import {
    GroupQueueEntry,
    useQueueTimeContext,
} from './useQueueTimeContext'
import {NinchatProperties} from 'api/types'
import {minBy} from 'lodash'

export type QueueDuration = {
    delivery_time?: NinchatProperties.Time
    queue_time: NinchatProperties.Time
    queueLength: number
    sourceQueueId?: NinchatProperties.QueueID
}

export const getQueueDuration = (
    queue: NinchatProperties.NinchatUserQueue | undefined,
    groupQueues: GroupQueueEntry[],
): QueueDuration => {
    if (!queue) {
        return {
            delivery_time: undefined,
            queueLength: 0,
            queue_time: 0,
        }
    }

    if (!queue.queue_attrs.is_group) {
        return {
            delivery_time: queue.delivery_time,
            queueLength: queue.queue_attrs.length ?? 0,
            queue_time: queue.queue_time ?? 0,
        }
    }

    const queueLength = groupQueues.reduce(
        (total, groupQueue) => total + (groupQueue.queueProps.queue_attrs.length ?? 0),
        0,
    )

    const longestWaitQueue = minBy(
        groupQueues.filter((groupQueue) => (groupQueue.queueProps.queue_attrs.length ?? 0) > 0 && (groupQueue.queueProps.queue_time ?? 0) > 0),
        (groupQueue) => groupQueue.queueProps.queue_time ?? 0,
    )

    return {
        delivery_time: longestWaitQueue?.queueProps?.delivery_time,
        queueLength,
        queue_time: longestWaitQueue?.queueProps?.queue_time ?? 0,
        sourceQueueId: longestWaitQueue?.id,
    }
}

export const useQueueDuration = (
    queue_id: NinchatProperties.QueueID,
): QueueDuration => {
    const {
        groupQueues,
        queue,
    } = useQueueTimeContext(queue_id)

    return getQueueDuration(queue, groupQueues)
}
